import { IApplicationState } from '../../types/redux';

export function getDeveloperName(state: IApplicationState) {
  return state.developer.name;
}
